module.exports = __webpack_public_path__ + "img/margot-speciaux.1dfb29f3.jpg";